import { AxiosError } from 'axios';

export function isApiError(e?: Error | null): e is AxiosError {
  if (!e) {
    return false;
  }

  return (e as AxiosError).response !== undefined;
}

export function isConflictError(e: Error | null): e is AxiosError {
  if (!e) {
    return false;
  }

  return isApiError(e) && e.response?.status === 409;
}

export function isUnauthorizedError(e?: Error | null): boolean {
  if (!e) {
    return false;
  }

  return isApiError(e) && e.response?.status === 401;
}

export function getApiErrorCode(e?: Error | null): number | undefined {
  if (isApiError(e)) {
    return e.response?.status;
  }

  return undefined;
}
